








































import Vue, { PropType } from 'vue';
import { Table, Header, HeaderCell, Row, Cell, Pagination } from '@aergoenterprise/lib-components/src/composite/tables';
import TableController from '@aergoenterprise/lib-components/src/container/TableController.vue';
import { Vertical } from '@aergoenterprise/lib-components/src/layout';
import { IconButton } from '@aergoenterprise/lib-components/src/composite/buttons';
import { Amount } from '@herajs/client';

export default Vue.extend({
  components: {
    Table, Header, HeaderCell, Row, Cell,
    TableController, Pagination,
    IconButton,
    Vertical,
  },
  props: {
    isLoading: Boolean,
    items: Array as PropType<any[]>,
  },
  data() {
    return {
      from: 0,
      sort: 'votes:desc',
    };
  },
  computed: {
    maxAmountLength(): number {
      // Get the length of the longest amount string
      return Math.max(...this.items.map(item => (item.getAmount() ? new Amount(item.getAmount(), 'aer').toUnit('aergo').toString() : '0 aergo').length));
    }
  },
  methods: {
    loadTableData({ sort, page }: any): void {
      this.from = page.offset;
      this.sort = `${sort.field}:${sort.asc?'asc':'desc'}`;
    },
    displayAmount(vote: any): string {
      // Pad amount with whitespace to make units line up
      try {
        return new Amount(vote.getAmount(), 'aer').toUnit('aergo').toString().padStart(this.maxAmountLength, " "); // U+2007 Figure Space
      } catch(e) {
        return ''; // old API
      }
    },
    getTextID(v: any) {
      if (v.getId() == 'voteBP') {
        return 'BP';
      }
      return v.getId();
    },
  },
});
